import pagination from './assets/pagination.js';
pagination();

import { buildSwiper } from './layouts/build-swiper.js';
buildSwiper();
import { mainSlide } from './layouts/main-slide.js';
mainSlide('.section-slide__body');